<template>
    <div>
        <a-row>
            <a-col :span="4"></a-col>
            <a-col :span="16">
                <div class="title">经济学院院聘行政人员学年考核表</div>
            </a-col>
            <a-col :span="4"></a-col>
        </a-row>
        <a-row>
            <a-col :span="8"></a-col>
            <a-col :span="8">
                <div class="schoolYear">{{detail.assessmentYear}}年度</div>
            </a-col>
            <a-col :span="8"></a-col>
        </a-row>

        <a-row>
            <a-col :span="24" style="margin-top: 20px;">
                <a-divider />
            </a-col>
        </a-row>

        <a-row>
            <a-col :span="6">
                <div class="info-item">
                    <span class="label">考核年份：</span>
                    <a-date-picker
                        class="input-box"
                        mode="year"
                        v-if="type == 'add'"
                        format='YYYY'
                        allowClear=false
                        placeholder="请选择考核年份"
                        v-model="detail.assessmentYear" 
                        :open='yearShowOne' 
                        @openChange="openChangeOne"
                        :disabled="!canEdit"
                        @panelChange="panelChangeOne"/>
                    <span v-else class="value">{{detail.assessmentYear}}年</span>
                </div>
            </a-col>
            <a-col :span="6">
                <div class="info-item">
                    <span class="label">姓名：</span>
                    <span class="value">{{detail.teacherName || '自动加载'}}</span>
                </div>
            </a-col>
            <a-col :span="6">
                <div class="info-item">
                    <span class="label">部门：</span>
                    <span class="value">{{detail.orgName || '自动加载'}}</span>
                </div>
            </a-col>
            <a-col :span="6">
                <div class="info-item">
                    <span class="label">职务/岗位：</span>
                    <a-input v-if="type == 'add' || type == 'edit'" v-model="detail.position" :disabled="!canEdit" style="width: 150px;"/>
                    <span v-else class="value">{{detail.position}}</span>
                </div>
            </a-col>
        </a-row>
        <a-row style="margin-top: 15px;">
            <a-col :span="6">
                
            </a-col>
        </a-row>

        <a-row>
            <a-col :span="24" style="margin-top: 20px;">
                <a-divider />
            </a-col>
        </a-row>

        <a-row>
            <a-col :span="24">
                <div class="section-title">岗位职责及任务</div>
                <a-textarea 
                    v-if="type == 'add' || type == 'edit'" 
                    v-model="detail.jobResponsibilities" 
                    :disabled="!canEdit"
                    placeholder="请填写岗位职责及任务..."
                    :maxLength="500"
                    :autoSize="{minRows: 6, maxRows: 10}"/>
                <div v-else class="content-box">{{detail.jobResponsibilities || '-'}}</div>
            </a-col>
        </a-row>

        <a-row>
            <a-col :span="24" style="margin-top: 20px;">
                <a-divider />
            </a-col>
        </a-row>

        <a-row>
            <a-col :span="24">
                <div class="section-title">本学年工作总结</div>
                <p class="hint">包括：工作业绩与效能，职业能力与素养，工作态度与服务精神，职业道德与廉洁自律（300字内）</p>
                <a-textarea 
                    v-if="type == 'add' || type == 'edit'" 
                    v-model="detail.workSummary" 
                    :disabled="!canEdit"
                    placeholder="请填写本学年工作总结..."
                    :maxLength="300"
                    :autoSize="{minRows: 8, maxRows: 12}"/>
                <div v-else class="content-box">{{detail.workSummary || '-'}}</div>
                <div v-if="(type == 'add' || type == 'edit')" class="word-count">已填写：{{detail.workSummary ? detail.workSummary.length : 0}}/300 字</div>
            </a-col>
        </a-row>

        <a-row v-if="type == 'view' || type == 'approve'">
            <a-col :span="24" style="margin-top: 20px;">
                <a-divider />
            </a-col>
        </a-row>

        <a-row v-if="type == 'view' || type == 'approve'">
            <a-col :span="24">
                <div class="section-title" :class="{ 'review-title': type == 'approve' }">
                    {{type == 'approve' ? '🏛️ 学院考核意见' : '🏆 考核结果'}}
                </div>
                
                <a-row v-if="type == 'approve'">
                    <a-col :span="24">
                        <div class="radio-group">
                            <span class="radio-label">综合评价：</span>
                            <a-radio-group v-model="approveForm.comprehensiveRating">
                                <a-radio value="excellent">优秀</a-radio>
                                <a-radio value="good">合格</a-radio>
                                <a-radio value="qualified">基本合格</a-radio>
                                <a-radio value="unqualified">不合格</a-radio>
                            </a-radio-group>
                        </div>
                    </a-col>
                    <a-col :span="24" style="margin-top: 20px;">
                        <span class="radio-label">审批意见：</span>
                        <a-textarea 
                            v-model="approveForm.approvalComments" 
                            placeholder="请输入审批意见..."
                            :autoSize="{minRows: 4, maxRows: 6}"
                            style="width: 100%;"/>
                    </a-col>
                </a-row>

                <a-row v-if="type == 'view' && detail.approvalStatus == 'approved'">
                    <a-col :span="12">
                        <div class="result-item">
                            <span class="label">综合评价：</span>
                            <a-tag color="green">{{getRatingText(detail.comprehensiveRating)}}</a-tag>
                        </div>
                    </a-col>
                    <!-- <a-col :span="12">
                        <div class="result-item">
                            <span class="label">审批人：</span>
                            <span class="value">{{detail.approverName}}</span>
                        </div>
                    </a-col> -->
                    <a-col :span="12">
                        <div class="result-item">
                            <span class="label">审核时间：</span>
                            <span class="value">{{detail.approvedAt}}</span>
                        </div>
                    </a-col>
                    <a-col :span="24" style="margin-top: 10px;">
                        <div class="result-item">
                            <span class="label">审批意见：</span>
                            <div class="content-box">{{detail.approvalComments || '-'}}</div>
                        </div>
                    </a-col>
                </a-row>

                <a-row v-if="type == 'view' && detail.approvalStatus != 'approved'">
                    <a-col :span="24">
                        <div class="no-result">
                            <a-empty description="考核结果待审核"/>
                        </div>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>

        <a-row>
            <a-col :span="24" style="margin-top: 30px;">
                <div class="btn-box">
                    <a-button @click="goBack">返回</a-button>
                    <a-button type="primary" @click="saveDraft" v-if="(type == 'add' || type == 'edit') && canEdit">暂存</a-button>
                    <a-button type="primary" @click="submitForm" v-if="(type == 'add' || type == 'edit') && canEdit">提交</a-button>
                    <a-button type="primary" @click="doApprove" v-if="type == 'approve'">通过审核</a-button>
                </div>
            </a-col>
        </a-row>
    </div>
</template>
<script>
    import { info, add, edit, commit, approve, getYears, checkYear } from '@/baseAPI/staffAssessment'

    export default {
        name: 'staffAssessmentDetail',
        components: {},
        data () {
            return {
                type: 'view',
                id: '',
                detail: {
                    id: '',
                    teacherId: '',
                    teacherName: '',
                    orgCode: '',
                    orgName: '',
                    position: '',
                    assessmentYear: '',
                    jobResponsibilities: '',
                    workSummary: '',
                    comprehensiveRating: '',
                    approvalComments: '',
                    approverName: '',
                    approvedAt: '',
                    approvalStatus: ''
                },
                approveForm: {
                    comprehensiveRating: '',
                    approvalComments: ''
                },
                availableYears: [],
                usedYears: [],
                yearShowOne: false
            }
        },
        computed:{
            canEdit(){
                return this.type == 'add' || (this.type == 'edit' && this.detail.approvalStatus == 'draft')
            }
        },
        mounted () {
            this.type = this.$route.query.type || 'view'
            this.id = this.$route.query.id
            
            if(this.type == 'add'){
                this.initAddData()
                this.getYears()
                this.checkAssessmentYear(this.detail.assessmentYear)
            }else{
                this.fetchDetail()
            }
        },
        methods:{
            initAddData(){
                const user = this.$store.state.user || {}
                this.detail.teacherId = user.userId || ''
                this.detail.teacherName = user.name || ''
                this.detail.orgCode = user.orgCode || ''
                this.detail.orgName = user.orgName || ''
                this.detail.assessmentYear = new Date().getFullYear() + ''
            },
            getYears(){
                getYears().then(res=>{
                    this.availableYears = res.data.availableYears || []
                    this.usedYears = res.data.usedYears || []
                    this.availableYears = this.availableYears.filter(y => !this.usedYears.includes(y))
                })
            },
            checkAssessmentYear(year){
                checkYear({ assessmentYear: year }).then(res=>{
                    if(res.data && res.data.data){
                        this.$notification.warning({
                            message: '提示',
                            description: `${year}年度考核记录已存在，无法新增，请选择其他年份`
                        })
                    }
                })
            },
            getTimeStr(time, format){
                let date = new Date(time)
                let year = date.getFullYear()
                return year
            },
            openChangeOne(status) {
                if (status) {
                    this.yearShowOne = true
                }
            },
            panelChangeOne(value) {
                this.detail.assessmentYear = this.getTimeStr(value._d, 'yyyy') + ''
                this.yearShowOne = false
                this.checkAssessmentYear(this.detail.assessmentYear)
            },
            fetchDetail(){
                info(this.id).then(res=>{
                    this.detail = res.data
                })
            },
            getRatingText(rating){
                switch(rating){
                    case 'excellent': return '优秀'
                    case 'good': return '合格'
                    case 'qualified': return '基本合格'
                    case 'unqualified': return '不合格'
                    default: return rating
                }
            },
            goBack(){
                this.$router.go(-1)
            },
            saveDraft(){
                if(!this.detail.position){
                    this.$notification['warning']({ message: '提示', description: '请填写职务/岗位' })
                    return
                }
                if(!this.detail.assessmentYear){
                    this.$notification['warning']({ message: '提示', description: '请选择考核年份' })
                    return
                }
                
                if(this.type == 'add'){
                    add(this.detail).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({ message: '成功', description: '保存成功' })
                            this.$router.go(-1)
                        }else{
                            this.$notification['error']({ message: '失败', description: res.data.errorMessage })
                        }
                    })
                }else{
                    edit(this.detail).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({ message: '成功', description: '保存成功' })
                            this.$router.go(-1)
                        }else{
                            this.$notification['error']({ message: '失败', description: res.data.errorMessage })
                        }
                    })
                }
            },
            submitForm(){
                if(!this.detail.position){
                    this.$notification['warning']({ message: '提示', description: '请填写职务/岗位' })
                    return
                }
                if(!this.detail.jobResponsibilities){
                    this.$notification['warning']({ message: '提示', description: '请填写岗位职责及任务' })
                    return
                }
                if(!this.detail.workSummary){
                    this.$notification['warning']({ message: '提示', description: '请填写本学年工作总结' })
                    return
                }
                
                if(this.type == 'add'){
                    add(this.detail).then(res=>{
                        if(res.data.success){
                            commit(res.data.data).then(res2=>{
                                if(res2.data.success){
                                    this.$notification['success']({ message: '成功', description: '提交成功' })
                                    this.$router.go(-1)
                                }else{
                                    this.$notification['error']({ message: '失败', description: res2.data.errorMessage })
                                }
                            })
                        }else{
                            this.$notification['error']({ message: '失败', description: res.data.errorMessage })
                        }
                    })
                }else{
                    commit(this.id).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({ message: '成功', description: '提交成功' })
                            this.$router.go(-1)
                        }else{
                            this.$notification['error']({ message: '失败', description: res.data.errorMessage })
                        }
                    })
                }
            },
            doApprove(){
                if(!this.approveForm.comprehensiveRating){
                    this.$notification['warning']({ message: '提示', description: '请选择综合评价' })
                    return
                }
                
                approve({
                    id: this.id,
                    comprehensiveRating: this.approveForm.comprehensiveRating,
                    approvalComments: this.approveForm.approvalComments
                }).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({ message: '成功', description: '审核成功' })
                        this.$router.go(-1)
                    }else{
                        this.$notification['error']({ message: '失败', description: res.data.errorMessage })
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .title{
        font-weight:bold;
        font-size: 1.5rem;
        text-align: center;
        margin-bottom: 1rem;
    }
    .schoolYear{
        text-align: center;
        color: #666;
    }
    .info-item{
        margin-bottom: 10px;
    }
    .info-item .label{
        color: #666;
        font-weight: bold;
    }
    .info-item .value{
        color: #333;
    }
    .section-title{
        font-size: 16px;
        font-weight: bold;
        color: #1890ff;
        margin-bottom: 15px;
        padding-left: 10px;
        border-left: 4px solid #1890ff;
    }
    .review-title{
        background: #f6ffed;
        padding: 10px 15px;
        border-radius: 6px;
        border-left: 4px solid #52c41a;
    }
    .hint{
        color: #999;
        font-size: 12px;
        margin-bottom: 10px;
    }
    .content-box{
        background: #f8f9fa;
        padding: 15px;
        border-radius: 6px;
        border: 1px solid #e8e8e8;
        min-height: 100px;
        white-space: pre-wrap;
    }
    .word-count{
        text-align: right;
        color: #999;
        font-size: 12px;
        margin-top: 5px;
    }
    .radio-group{
        display: flex;
        align-items: center;
        gap: 20px;
        flex-wrap: wrap;
    }
    .radio-label{
        font-weight: bold;
        color: #666;
    }
    .result-item{
        margin-bottom: 15px;
    }
    .result-item .label{
        color: #666;
        font-weight: bold;
        margin-right: 10px;
    }
    .result-item .value{
        color: #333;
    }
    .no-result{
        text-align: center;
        padding: 40px;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 15px;
    }
</style>
